import { CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import MyAccount from "../../../components/users/account/myAccount/MyAccount";

const MyAccountManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.my.account")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <MyAccount />
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default MyAccountManagement;
